/**
 * Normalizes the given URL path
 *
 * @param path - The path to normalize
 *
 * @returns The normalized path
 * @example
 * ```ts
 * const normalizedPath = normalizeUrlPath('dashboard');
 * console.log(normalizedPath); // /dashboard
 *
 * const normalizedPath = normalizeUrlPath('/dashboard');
 * console.log(normalizedPath); // /dashboard
 *
 * const normalizedPath = normalizeUrlPath('dashboard/');
 * console.log(normalizedPath); // /dashboard
 *
 * const normalizedPath = normalizeUrlPath('');
 * console.log(normalizedPath); // ''
 * ```
 */
export const normalizeUrlPath = (path?: string): string => {
  const normalizedPath = path?.startsWith('/') ? path : path ? `/${path}` : '';
  return normalizedPath.endsWith('/') ? normalizedPath.slice(0, -1) : normalizedPath;
};
